module.exports = __webpack_public_path__ + "img/qumo.32ac0768.png";